import React, { useMemo, useState, useContext } from 'react';
import { ButtonPrimary, Spinner } from '../../StyledComponent';

import { Context } from '../../../services/auth';
import BaseComponentChangeData from '../../BaseComponentChangeData';

import ChangeEmailPassword from '../../ChangeEmailPassword';
import changeEmailRequests from '../../../services/changeEmailRequests';
import Cognito from '../../../Amplify';
import { ContextoListaApartamentos } from '../../ApartamentList/contextoImoveis';

import HeaderSection from '../../HeaderSection';
import Input from '../../Input';
import './styles.scss';
import { ContainerFoundEmail } from './styles';

import ResendCode from '../ResendCode';
import MessagePopUp from '../../MessagePopup';
import { ArrowBack } from '@material-ui/icons';
import { maskEmail } from '../../../Utils/masks';
const FoundEmail = ({ cpf, email, toggleFoundEmail }) => {
  const [verifyCode, setVerifyCode] = useState('');

  const [showTrocaSenha, setShowTrocaSenha] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const { confirmSignUTrocaEmail } = useContext(Context);

  const [showResendCodeModal, setShowResendCodeModal] = useState(false);
  const [isShowSuccessModal, setIsShowSuccessModal] = useState(false);
  const [isShowErrorInvalidCodeModal, setIsShowErrorInvalidCodeModal] =
    useState(false);
  const [isShowGenericError, setIsShowGenericError] = useState(false);
  const { tema } = useContext(ContextoListaApartamentos);

  const maskedEmail = useMemo(() => maskEmail(email), []);

  async function confirmaUsuario() {
    try {
      setIsLoading(true);

      let resultSignUp = '';
      resultSignUp = await confirmSignUTrocaEmail(email, verifyCode);

      if (
        resultSignUp?.code === 'CodeMismatchException' ||
        resultSignUp?.code === 'ExpiredCodeException'
      ) {
        setIsShowErrorInvalidCodeModal(true);
        return;
      }

      const resultChangeEmailSales =
        await changeEmailRequests.changeEmailSalesForce(email);

      if (resultChangeEmailSales) {
        await Cognito.softSignOut();
        setShowTrocaSenha(true);
        setIsShowSuccessModal(true);
        return;
      }

      setIsShowGenericError(true);
    } catch (error) {
      console.error(error);
      return false;
    } finally {
      setVerifyCode('');
      setIsLoading(false);
    }
  }

  return (
    <>
      <>
        {showTrocaSenha ? (
          <ChangeEmailPassword cpf={cpf} email={email} />
        ) : (
          <BaseComponentChangeData>
            <ContainerFoundEmail tema={tema}>
              <div>
                <HeaderSection
                  tema={tema}
                  notShowButton
                  title={'Autenticação em dois fatores'}
                  subtitle={
                    'Enviamos um código de verificação para o e-mail cadastrado:'
                  }
                />
                <div>
                  <p className='email-masked'>{maskedEmail}</p>
                  <Input
                    id='txtVerifyCode'
                    inputMode={'numeric'}
                    placeholder='CÓDIGO'
                    maxLength='6'
                    value={verifyCode}
                    handleInputChange={(e) => setVerifyCode(e.target.value)}
                    marginTop={0}
                  />
                </div>
                <div className='container-buttons'>
                  <ButtonPrimary
                    tema={tema}
                    light
                    fullWidth
                    disabled={isLoading}
                    onClick={() => setShowResendCodeModal(true)}
                  >
                    REENVIAR CÓDIGO
                  </ButtonPrimary>
                  <ButtonPrimary
                    tema={tema}
                    fullWidth
                    onClick={confirmaUsuario}
                    disabled={isLoading || verifyCode.length < 6}
                  >
                    {isLoading ? (
                      <>
                        <span>CARREGANDO...</span>
                        <Spinner />
                      </>
                    ) : (
                      <span>CONFIRMAR</span>
                    )}
                  </ButtonPrimary>
                </div>
                <div className='backButton'>
                  <span onClick={toggleFoundEmail}>
                    <ArrowBack />
                    VOLTAR
                  </span>
                </div>
              </div>
            </ContainerFoundEmail>

            {showResendCodeModal && (
              <ResendCode
                email={email}
                tema={tema}
                setShowResendModal={() => setShowResendCodeModal(false)}
              />
            )}

            {isShowSuccessModal && (
              <MessagePopUp
                title={'E-mail alterado com sucesso!'}
                message={'O seu novo e-mail foi cadastrado com sucesso.'}
              >
                <ButtonPrimary
                  tema={tema}
                  fullWidth
                  onClick={() => setIsShowSuccessModal(false)}
                >
                  FECHAR
                </ButtonPrimary>
              </MessagePopUp>
            )}

            {isShowErrorInvalidCodeModal && (
              <MessagePopUp
                isError
                title={'Código inválido!'}
                message={
                  'O código digitado é inválido ou expirou, verifique por gentileza.'
                }
              >
                <ButtonPrimary
                  tema={tema}
                  fullWidth
                  onClick={() => setIsShowErrorInvalidCodeModal(false)}
                >
                  FECHAR
                </ButtonPrimary>
              </MessagePopUp>
            )}

            {isShowGenericError && (
              <MessagePopUp
                isError
                title={'Erro!'}
                message={'Ocorreu um erro, por favor tente novamente!'}
              >
                <ButtonPrimary
                  tema={tema}
                  fullWidth
                  onClick={() => setIsShowGenericError(false)}
                >
                  FECHAR
                </ButtonPrimary>
              </MessagePopUp>
            )}
          </BaseComponentChangeData>
        )}
      </>
    </>
  );
};

export default FoundEmail;
